import { FC, useState } from "react";

import { List, ListItem, ListItemIcon, Box, Drawer } from "@mui/material";
import { NavLink } from "react-router-dom";

import classes from "./NavigationDrawer.module.scss";
import { SiteNavConfig } from "./NavigationDrawerModels";
import { drawerStyling } from "../../../common/Mui/MuiStyling";
import { getCssVariable } from "../../../cssVarUtils";

interface INavigationDrawerProps {
  navigationItems: SiteNavConfig[];
  navigationPrefix?: string;
  siteGroupId?: number;
}

const NavigationDrawer: FC<INavigationDrawerProps> = ({
  navigationItems,
  navigationPrefix,
  siteGroupId,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const handleMouseHover = (index: number) => setHoveredIndex(index);
  const handleMouseOut = () => setHoveredIndex(null);
  const activeListItemColor = getCssVariable("--nav-active-list-item-color");
  const inactiveListItemColor = getCssVariable("--nav-list-item-color");
  return (
    <Box sx={{ display: "flex" }}>
      <Drawer variant="permanent" sx={drawerStyling}>
        <List className={classes["list"]}>
          {navigationItems.map((item, index) => {
            return (
              <NavLink
                to={navigationPrefix ? `${navigationPrefix}${item.pagePath}` : item.pagePath}
                state={siteGroupId === undefined ? undefined : { siteGroupId }}
                key={item.pagePath}
                style={{ textDecoration: "none" }}
              >
                {({ isActive }) => {
                  const isHovered = hoveredIndex === index;
                  const ItemIcon = item.icon;
                  return (
                    <ListItem
                      className={`${classes["list-item"]} ${isActive ? classes.active : ""} ${isHovered ? classes.hovered : ""}`}
                      key={item.pagePath}
                      onMouseOver={() => handleMouseHover(index)}
                      onMouseOut={handleMouseOut}
                    >
                      <ListItemIcon>
                        <ItemIcon
                          className={`${classes["icon"]} ${isHovered ? classes["icon-hovered"] : ""}`}
                          backgroundColor={isActive ? inactiveListItemColor : activeListItemColor}
                          strokeColor={"white"}
                        />
                      </ListItemIcon>
                      <div className={classes["label"]}>{item.pageName}</div>
                    </ListItem>
                  );
                }}
              </NavLink>
            );
          })}
        </List>
      </Drawer>
    </Box>
  );
};

export default NavigationDrawer;
